import React, { useEffect, useState } from 'react'
import { useScreenSize } from '@hypatia/react-hooks/ScreenSize'

interface Props {
    style?: React.CSSProperties
}
export default React.memo(ModernSuspenseLoading)
function ModernSuspenseLoading({ style }: Props) {
    const [timePassed, setTimePassed] = useState(false)
    const isSm = useScreenSize() === 'sm'

    useEffect(() => {
        if (!isSm) {
            return
        }

        setTimeout(() => setTimePassed(true), 500)
    }, [isSm])

    if (!timePassed && isSm) {
        return null
    }

    return (
        <div className="spinner-container" style={style}>
            <span className="spinner-span-container">
                <svg
                    className="spinner-icon"
                    focusable="false"
                    height="96"
                    viewBox="0 0 96 96"
                    width="96"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="48" cy="48" r="43" />
                </svg>
            </span>
        </div>
    )
}
